// puze 专用的router
export const puzeRoutes = [
  {
    path: "/puze-micropage",
    name: "puze-micropage",
    title: "普泽微页面",
    meta: {
      title: "\u200E",
      bridge: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "puze-micropage" */ "../views/puze-micropage/index.vue"
      ),
  },
];
